<template>
  <div class="account-addresses">
    <div class="delivery-addresses">
      <div class="title">
        <f-sprite-icon :icon-link="$options.icons.IconBox.id" />
        <h2>Адреса доставки</h2>
      </div>

      <div
        v-if="sortedAddresses.length !== 0"
        class="list"
      >
        <address-card
          v-for="address in sortedAddresses"
          :key="address.id"
          :address="address"
          @on-primary="setPrimary(address)"
          @on-edit="openAddressModal(address)"
          @on-removed="LOAD_ADDRESSES"
        />

        <div>
          <ui-notification
            v-if="ADDRESSES.length >= 10"
            class="limit"
            title="Невозможно добавить более 10 адресов доставки"
            color="#FFB71B"
          >
            Отредактируйте текущие или удалите лишние
          </ui-notification>
          <address-card
            button="Добавить адрес"
            :disabled="ADDRESSES.length >= 10"
            @open="openAddressModal(defaultAddress)"
          />
        </div>
      </div>

      <page-info
        v-else
        class="page-info"
        title="Список адресов пуст"
        subtitle="Добавьте адрес доставки, чтобы использовать его при оформлении заказа"
      >
        <ui-button
          text="Добавить адрес"
          @click="openAddressModal(defaultAddress)"
        />
      </page-info>
    </div>
    <!-- Для блока ниже пока не готово апи -->
    <div
      v-if="false"
      class="favourite-shops"
    >
      <div class="title">
        <f-sprite-icon :icon-link="$options.icons.IconPoint.id" />
        <h2>Избранные магазины</h2>
      </div>
      <div class="list">
        <address-card
          title="БЦ «Водный стадион»"
          description="Москва, Волгоградский пр-кт 26/1, 2 этаж"
        >
          <div
            slot="button"
            @click="openedAddressModal = true"
          >
            <f-sprite-icon slot="button" :icon-link="$options.icons.IconBin.id" />
          </div>
        </address-card>
        <address-card
          button="Добавить магазин"
          @open="openedAddressModal = true"
        />
      </div>
    </div>

    <modal
      :visible="openedAddressModal"
      @on-close="openedAddressModal = false"
    >
      <address-form
        :address="editableAddress"
        :change-primary="ADDRESSES.length >= 1"
        @on-close="openedAddressModal = false"
        @success="successForm"
      />
    </modal>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
/* Icons */
import IconBox from '../../assets/icons/box.svg';
import IconPoint from '../../assets/icons/point.svg';
import IconBin from '../../assets/icons/bin.svg'
/* Components */
import AddressCard from '../../components/account/address-card';
import AddressForm from '../../components/account/address-form';
import PageInfo from '../../components/common/page-info';

export default {
  name: 'account-addresses',

  components: {
    PageInfo,
    AddressForm,
    AddressCard
  },

  icons: {
    IconBox,
    IconPoint,
    IconBin
  },

  data() {
    return {
      openedAddressModal: false,
      orderIds: [],
      defaultAddress: {
        name: '',
        cityName: '',
        cityId: '',
        metroStationName: '',
        streetName: '',
        house: '',
        houseBlock: '',
        building: '',
        entrance: '',
        floor: '',
        apartment: '',
        postalCode: '',
        primary: false,
      },
      editableAddress: {},
    };
  },

  computed: {
    ...mapGetters({
      ADDRESSES: 'user/addresses',
    }),

    sortedAddresses() {
      // Адреса, которые есть в сортировке
      const addresses = [];
      this.orderIds.forEach(id => {
        const a = this.ADDRESSES.find(addr => addr.id === id);
        if (a) addresses.push(a);
      });
      // Адреса, которые не пришли сразу
      const newAddresses = this.ADDRESSES.filter(a => !this.orderIds.includes(a.id));
      newAddresses.forEach(({ id }) => this.orderIds.push(id));
      return [...addresses, ...newAddresses];
    }
  },

  created() {
    if (this.$isServer) return;
    // запоминаем начальный порядок адресов
    this.orderIds = this.ADDRESSES.map(a => a.id);
  },

  methods: {
    ...mapActions({
      LOAD_ADDRESSES: 'user/loadAddresses',
    }),

    setPrimary(address, retryCount = 0) {
      this.editableAddress = {...address, primary: true};
      this.$store.$api.updateAddress({ address: this.editableAddress })
          .then(() => {
            this.LOAD_ADDRESSES();
          }).catch(e => {
            // костыль на проблему ошибки 429(Too many requests)
            console.warn(e);
            retryCount++;
            retryCount < 3 && setTimeout(this.setPrimary, 5000, address, retryCount);
        });
    },

    openAddressModal(val) {
      this.editableAddress = val;
      // отсутствие свойства в объекте адреса ломает селект в форме
      if (!this.editableAddress?.metroStationName) this.editableAddress.metroStationName = '';
      this.openedAddressModal = true;
    },

    successForm() {
      this.LOAD_ADDRESSES();
      this.openedAddressModal = false;
    },
  },

  serverPrefetch() {
    return this.LOAD_ADDRESSES();
  }
};
</script>

<style lang="scss">
.account-addresses {
  .delivery-addresses,
  .favourite-shops {
    display: flex;
    flex-direction: column;

    & > .title {
      display: flex;
      align-items: center;
      margin-top: 32px;
      margin-bottom: 20px;

      svg {
        margin-right: 4px;
      }
    }

    & > .list {

      & > div {
        margin-top: 16px;
      }

      & > div:first-child {
        margin-top: 0;
      }
    }

    .page-info {
      margin-top: 56px;
      margin-bottom: 134px;

      &-icon {
        svg {
          width: 64px;
          height: 64px;
        }
      }
    }

    .limit {
      margin-top: 0;

      .ui-notification-subtitle {
        font-size: 12px;
        line-height: 16px;
      }
    }

    .actions {
      display: flex;
      flex-direction: column;
      padding: 8px 0;
      border-radius: 4px;

      & > span {
        min-width: 152px;
        padding: 8px 12px;
        font-size: 14px;
        line-height: 24px;
        font-weight: 500;
        cursor: pointer;
        transition: .2s background-color ease;

        &:hover {
          background-color: $gray_bgr;
        }
      }
    }
  }

  .modal {
    z-index: 50;

    &-content {
      width: 100%;
      height: 100%;
      max-height: 100%;
      padding: 44px 16px;
      border-radius: 0;
    }
  }
}

@include breakpoint("tablet") {
  .account-addresses {
    .delivery-addresses,
    .favourite-shops {
      & > .title {
        margin-bottom: 4px;

        svg {
          margin-right: 13px;
        }
      }

      & > .list {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        flex-wrap: wrap;

        & > div {
          width: calc(50% - 8px);
        }

        & > div:first-child {
          margin-top: 16px;
        }

        & > div:nth-child(2n + 1) {
          margin-right: 16px;
        }
      }

      .page-info {
        margin-top: 80px;
        margin-bottom: 224px;
      }
    }

    .modal {
      &-content {
        padding: 56px 32px;
      }
    }

    .close-button {
      top: 12px;
      right: 12px;
      width: auto;
      height: auto;
      padding: 0;
    }
  }
}

@include breakpoint("desktop") {
  .account-addresses {

    .delivery-addresses,
    .favourite-shops {
      & > .title {
        margin-top: 40px;
        margin-bottom: 8px;
      }

      & > .list {
        .page-info {
          margin-top: 64px;
          margin-bottom: 360px;
        }

        .limit {
          .ui-notification-subtitle {
            font-size: 14px;
          }
        }

        & > div {
          width: calc(50% - 12px);
        }

        & > div,
        & > div:first-child {
          margin-top: 24px;
        }

        & > div:nth-child(2n + 1) {
          margin-right: 24px;
        }
      }
    }

    .delivery-addresses {
      & > .title {
        margin-top: 0;
        margin-bottom: 0;
      }
    }

    .modal {
      &-content {
        padding: 56px 108px;
      }
    }

    .close-button {
      top: 24px;
      right: 24px;
    }
  }
}
</style>
